!function($) {

  // Add custom JavasScript here
  // --------------------------


  /* HC - Updating changes for Ingredient List - 09 April '21 */
  // Document ready
  $(function() {
    $('#class-fields').change(function(){
        var Value = $(this).val();
      	if(Value === 'Just the class (you buy the ingredients)')
        {
          	if($('#hcclasses').hasClass('hcadded'))
            {}
          	else
            {
          		$('.shopify-product-form').append('<input id="hcclasses" class="hcadded" type="hidden" name="properties[_Without Ingredient]" value="Yes">');
            }
        }
      	else
        {
          	$('#hcclasses').remove();
        }
    });
    
    /* HC - If product doesn't have foodpackage set without ingredients to Yes - 10 May '21 */
    if($('#class-fields').length == 0){
      $('.shopify-product-form').append('<input id="hcclasses" class="hcadded" type="hidden" name="properties[_Without Ingredient]" value="Yes">');
    }
  });
  
  /* HC - Updating changes for Clearing whole cart - 13 April '21 */
  $(function() {
    $('.hcfoodremove').click(function(e){
        console.log('click trigger');
    	$('.hcclearwhole').trigger('click');
    })
  });

}(jQuery);